import { Stack } from '@mui/material';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { ImageContainer } from './Filters.components';
import { ControlledInputs, Grid } from '@/components';
import { useForm } from 'react-hook-form';

export const EditExperienceBody = () => {
  const form = useForm();
  return (
    <Stack direction="row" px={4} py={8} gap={4}>
      <Stack width="30%">
        <ImageContainer>
          <BrokenImageIcon fontSize="large" />
        </ImageContainer>
      </Stack>
      <Stack width="70%" gap={2}>
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Experience Type"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Experience Name"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Experience Email"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Experience Website"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Address"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Phone"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'company.company_name',
            disabled: true,
          }}
          label="Description"
        />
        <Grid columns={2} gap={20}>
          <ControlledInputs.DatePicker
            ControllerProps={{
              control: form.control,
              name: 'company.company_name',
              disabled: true,
            }}
            label="Start Date"
          />
          <ControlledInputs.DatePicker
            ControllerProps={{
              control: form.control,
              name: 'company.company_name',
              disabled: true,
            }}
            label="End Date"
          />
        </Grid>
      </Stack>
    </Stack>
  );
};
